import Model from "./base/model";

class OrderDeliveryAddress extends Model {
  resourceName() {
    return "order_delivery_addresses";
  }

  fields() {
    return {
      observation: "",
      destinatary_name: "",
      destinatary_identification_document: "",
      air_plane_type: "",
      delivery_vehicle: "",
      delivery_modal: "",
      is_natural_person: "",
      street: "",
      number: "",
      district: "",
      postal_code: "",
      complement: "",
      city_id: "",
      city: "",
      state: "",
      uf: "",
      delivery_status: "",
      delivery_date_time: "",
      expected_delivery_date_time: "",
      real_date_time_justification: "",
      on_destiny_status: "",
      on_destiny_date_time: "",
      latitude: "",
      longitude: "",
      address_id: "",
      linked_invoices: "",
      linked_dces: "",
      linked_value: "",
      linked_invoices_values: "",
      is_stop_point: "",
      map_url: "",
      fractionate_delivery_date_time: "",
      freight_type: "",
      linked_requests: "",
    };
  }

  async deliver(id, data) {
    return this.request(
      "orders/" + this.resourceName() + "/deliver/" + id,
      "POST",
      {},
      data,
    );
  }
  async onDestiny(id, data) {
    return this.request(
      "orders/" + this.resourceName() + "/on_destiny/" + id,
      "POST",
      {},
      data,
    );
  }
}

export default new OrderDeliveryAddress();
